import { Avatar, Box, Chip, useTheme } from '@mui/material'
import { colorOptions } from 'shared-lib/timeHelpers'
import { contrastColor, nameWithOption } from 'shared-lib/utils'
import { getImageKitUrl } from '~/components/Image'
import { useDevicePixelRatio } from '~/lib/hooks/useDevicePixelRatio'
import { spacingToNumber } from '~/theme/default'

interface ProfileAvatarProps {
  color?: string
  fullName: string
  size?: number
  src?: string | null
  tag?: string
}

function colorFromName(name: string): string {
  let hash = 0
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash)
  }
  return colorOptions[Math.abs(hash) % colorOptions.length]
}

export const ProfileAvatar = ({ color, fullName, size = 6, src, tag }: ProfileAvatarProps) => {
  const theme = useTheme()
  const devicePixelRatio = useDevicePixelRatio()
  const sizePx = spacingToNumber(theme.spacing(size))
  const imageSrc = src
    ? getImageKitUrl(src, { width: sizePx, height: sizePx, devicePixelRatio })
    : undefined

  const bgcolor = color || colorFromName(fullName)

  const avatar = (
    <Avatar
      src={imageSrc}
      sx={{
        width: theme.spacing(size),
        height: theme.spacing(size),
        boxSizing: 'border-box',
        border: `${theme.spacing(0.5)} solid`,
        borderColor: src ? bgcolor : 'rgba(0, 0, 0, 0.15)',
        bgcolor,
        color: contrastColor(bgcolor),
        fontSize: sizePx * 0.4,
        fontWeight: 'medium',
      }}
      alt={fullName}
    >
      {nameWithOption('FirstInitial', fullName, '')}
    </Avatar>
  )

  if (!tag) return avatar

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      {avatar}
      <Chip
        size='small'
        label={tag}
        sx={{
          position: 'absolute',
          zIndex: 2,
          bottom: 0,
          left: '50%',
          transform: 'translate(-50%, 20%)',
          bgcolor,
          color: 'common.white',
        }}
      />
    </Box>
  )
}
